export const minMainContainerTabletHeight = 680
